import styled from 'styled-components';
import { type FlexItemProps, type FlexProps } from './Flex.types';

const Flex = styled('div').withConfig({
  shouldForwardProp: (prop) =>
    !['alignItems', 'alignSelf', 'flexDirection', 'justifyContent', 'zIndex', 'flexWrap'].includes(
      prop,
    ),
})<FlexProps>`
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};
  align-self: ${({ alignSelf }) => alignSelf || 'auto'};
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
  flex-wrap: ${({ flexWrap }) => flexWrap || 'inherit'};
  height: ${({ height }) => height || `auto`};
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  position: ${({ position }) => position || `relative`};
  width: ${({ width }) => width || `100%`};
  z-index: ${({ zIndex }) => zIndex || 'auto'};
  gap: ${({ gap }) => gap || 'normal'};
`;

Flex.displayName = 'Flex';

const FlexItem = styled('div').withConfig({
  shouldForwardProp: (prop) => !['flexBasis', 'alignSelf'].includes(prop),
})<FlexItemProps>`
  align-self: ${({ alignSelf }) => alignSelf || 'flex-start'};
  flex: ${({ flex }) => flex || '0 1 auto'};
  flex-basis: ${({ flexBasis }) => flexBasis || 'none'};
  order: ${({ order }) => order || '0'};
`;

const defaultExport = Object.assign(Flex, { Item: FlexItem });

export default defaultExport;
